export default "__VITE_ASSET__5689a430__"